import myPagesReducer, {
  $$initialState as $$myPagesState,
} from './myPagesReducer';
import railsContextReducer, {
  initialState as railsContextState,
} from './railsContextReducer';
import notificationBadgeDuck from '../redux/modules/notificationBadgeDuck';
import dashboardDuck from '../redux/modules/dashboardDuck';
import programDuck from '../redux/modules/programDuck';
import settingsDuck from '../redux/modules/settingsDuck';
import registrantsDuck from '../redux/modules/registrantsDuck';
import downloadsDuck from '../redux/modules/downloadsDuck';

export default {
  $$myPagesStore: myPagesReducer,
  $$notificationBadgeStore: notificationBadgeDuck.reducer,
  $$dashboardStore: dashboardDuck.reducer,
  $$downloadsStore: downloadsDuck.reducer,
  $$programStore: programDuck.reducer,
  $$settingsStore: settingsDuck.reducer,
  [registrantsDuck.store]: registrantsDuck.reducer,
  railsContext: railsContextReducer,
};

export const initialStates = {
  $$myPagesState,
  railsContextState,
  $$dashboardState: dashboardDuck.initialState,
  $$downloadsState: downloadsDuck.initialState,
  $$programState: programDuck.initialState,
  $$settingsState: settingsDuck.initialState,
  $$organizerRegistrantsState: registrantsDuck.initialState,
};
